<div *ngIf="errorMessage" class="alert alert-danger alert-dismissable">
    <strong>Erro ao buscar ficha: </strong> {{errorMessage}}
</div>

<app-central-loader [show]="isGettingFicha && !errorMessage" text="Obtendo Ficha Proposta..."></app-central-loader>

<div role="tabpanel" class="tab-pane " id="formD" *ngIf="!isGettingFicha && !errorMessage">
    <h2>Resultado Parcial <span class="fa fa-spinner fa-pulse" aria-hidden="true" *ngIf="isExecutandoSimulacao"></span>
    </h2>

    <seguro
      *ngIf="fichaCadastro.garantias?.length && proposta.id"
      [grupoAssistenciaIds]="simulacao.seguro.gruposAssistenciaIds"
      [grupoSeguroIds]="simulacao.seguro.gruposSeguroIds"
      [retornoMax]="proposta.taxaCliente.retornoMax"
      [retorno]="simulacao.seguro.retorno"
      [proposta]="proposta.id"
      [cpf]="proposta.cliente.cpf"
      [isZeroKm]="fichaCadastro.isZeroKm"
      [anoModelo]="fichaCadastro.garantias[0].anoModelo || '0'"
      [gruposSeguros]="proposta.gruposSeguros"
      [gruposAssistencias]="proposta.gruposAssistencias"
      (seguroSelected)="onChangeSeguro($event)">
    </seguro>



    <div class="row">
        <div class="col-xs-12">
            <div class="panel blue">
                <span class="icon"></span>
            </div>

            <veiculo [fichaCadastro]="fichaCadastro" [veiculo]="(proposta.veiculos[0] || {})" [proposta]="proposta" (veiculoAlterar)="onUpdateVeiculo()"></veiculo>

            <app-valor-financiado [cotacao]="(proposta.veiculos[0] || {}).cotacao || 0" [valorSimular]="simulacao.valor" [disabled]="isExecutandoSimulacao" (valorSimularChange)="onChangeValorSimular($event)"></app-valor-financiado>

            <parcela [proposta]="proposta" [simulacao]="simulacao" [parcelasSimuladas]="parcelasSimuladas" (simular)="onChangeParcela($event)"></parcela>

        </div>
    </div>
    <div class="row">
        <div class="marginT30 clean-panel tab-buttons">
            <a (click)="onClickNext()" class="bt-go btn btn-full-orange pull-right" [ngClass]="{'disabled': isButtonNextDisabled || isExecutandoSimulacao }">Continuar <em class="fa fa-arrow-right mlBt"></em></a>
        </div>
    </div>
</div>

<app-modal-message #modalMessage [title]="'Atenção!'" [hideClose]="true"></app-modal-message>

<app-modal-message #modelAttentionMessage [title]="'Atenção!'" [hideClose]="false" [labelOk]="'Continuar'" [labelClose]="'Voltar'" (ok)="onReturnContinueAttentionMessageZeroStar()"></app-modal-message>

<app-new-modal-message #messageModal [showFecharBtn]="false"></app-new-modal-message>
